import { gql } from "@apollo/client";

export const GET_DERIVACION_PRESCRIPTOR_ADJUNTO = gql`
query evaluacionById ($idEvaluacion: Int!) {
    evaluacionById (idEvaluacion: $idEvaluacion){
        derivacionPrescriptor{
            contentType 
            titulo
            archivo
            extension
            fechaAlta
        }
    }
}`;